import * as React from "react";
import { Route, Switch } from "react-router";
import { NotFoundSite } from "../sites/NotFoundSite";

type Props = { children: React.ReactNode };

export const CustomSwitch = ({ children }: Props) => (
    <Switch>
        {children}
        <Route component={NotFoundSite} />
    </Switch>
);
